import React from 'react';
import { generateSlideImageUrl } from '@utils/generateAssetLinks';
import { SlideIcon } from '../styles';

export const SlideImage = ({ name, alt }) => (
    <SlideIcon
        alt={alt}
        src={generateSlideImageUrl(name)} />
);

export default SlideImage;
